import clsx from 'clsx';
import NextLink from 'next/link';
import { forwardRef } from 'react';

import type { Size } from '@/utils/globalTypes';

import styles from './Link.module.css';
interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  href: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  size?: Size;
}

function LinkComponent(
  { children, className, href, iconLeft, iconRight, size = 'md', ...rest }: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  return (
    <NextLink ref={ref} href={href} className={clsx(styles.link, styles[size], className)} {...rest}>
      {iconLeft}
      {children}
      {iconRight}
    </NextLink>
  );
}

LinkComponent.displayName = 'Link';
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(LinkComponent);
